import React from "react";
import { Box, Chip, Grid, styled, Typography, useTheme } from "@mui/material";
import { useIsMobile } from "../../hooks/responsive";
import { CenteredSiteBlock } from "../../routes/Home";
import {
  PictureAsPdfRounded,
  CheckCircleOutlineRounded,
} from "@mui/icons-material";

import logo from "../../resources/images/svg/inexplore-logo-white.svg";
import { ReactComponent as Comitee } from "../../resources/images/svg/home/joinUs/comitee.svg";
import { ReactComponent as PartnerCheck } from "../../resources/images/svg/home/joinUs/partnerCheck.svg";
import { ReactComponent as Level1Arrow } from "../../resources/images/svg/home/joinUs/level1arrow.svg";
import { ReactComponent as Level2Arrow } from "../../resources/images/svg/home/joinUs/level1arrow.svg";
import { ReactComponent as ArrowRightBackground } from "../../resources/images/svg/home/joinUs/arrowRightBackground.svg";
import { ReactComponent as ZoomBg } from "../../resources/images/svg/home/zoomIcon3.svg";
import labelImage from "../../resources/images/png/home/joinUs/label.png";
import referencesPracticesImage from "../../resources/images/png/home/joinUs/referencesPractices.png";
import SpecialCard from "../card/SpecialCard";
import InexButton from "../InexButton";
import RainbowDivider from "../misc/RainbowDivider";
import { GradientTypo } from "../header/Header";
import pratiquesJpg from "../../resources/images/jpg/100pratiques.jpg";
import Reasons5 from "./Reasons5";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    minHeight: "100px",
    backgroundColor: theme.palette.blackPro,
    position: "relative",
  };
});

const JoinUs = () => {
  const isMobile = useIsMobile();
  const theme = useTheme();

  return (
    <Container className={"develop-alliances"}>
      <CenteredSiteBlock
        sx={{
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundSize: "stretch",
          backgroundPosition: "top",
          marginTop: (theme) => theme.spacing(isMobile ? 5 : 10),
          marginBottom: (theme) => theme.spacing(isMobile ? 5 : 0),
          display: "flex",
          flexDirection: "column",
          paddingLeft: "20px",
          paddingRight: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            width: "100%",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: { xs: "100%", md: "50%" },
              marginRight: "20px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {!isMobile && (
                <img
                  src={labelImage}
                  alt={"trusted label icon"}
                  style={{
                    width: "170px",
                    height: "155px",
                  }}
                />
              )}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  mb: 2,
                }}
              >
                <Typography
                  variant={"h2"}
                  sx={{
                    fontSize: { xs: "30px", lg: "30px" },
                    color: "white",
                    margin: "5px 0",
                  }}
                >
                  Développez votre visibilité et crédibilité grâce au label
                </Typography>
                <img src={logo} alt={"logo"} width={"75%"} height={"40px"} />
              </Box>
            </Box>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "white",
                textAlign: "center",
                margin: 0,
                zIndex: 1,
              }}
            >
              Parce que faire reconnaître votre démarche, c’est aussi donner
              confiance à ceux qui cherchent un accompagnement aligné et
              éclairé.
            </Typography>
            <Comitee
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                filter: "drop-shadow(0 0 2rem #9A45F488)",
              }}
            />
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "white",
                textAlign: "center",
                margin: 0,
                zIndex: 1,
                maxWidth: "90vw",
              }}
            >
              Dans un monde en quête de repères, ce label distingue les praticiens 
              dont la posture, l’éthique et le professionnalisme sont en cohérence 
              avec les valeurs portées par Inexploré depuis près de vingt ans.
            </Typography>
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "white",
                textAlign: "center",
                margin: 0,
                zIndex: 1,
                marginTop: 2,
                maxWidth: "90vw",
              }}
            >
              Être labellisé Inexploré Praticiens, c’est inspirer confiance au public et 
              rejoindre une communauté engagée pour faire progresser les pratiques 
              d’accompagnement.
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: { xs: "100%", md: "50%" },
              marginTop: { xs: 3, lg: 0 },
            }}
          >
            <SpecialCard
              containerProps={{
                sx: {
                  "&:hover": {
                    transform: "none",
                  },
                },
              }}
              sx={{
                padding: 7,
                maxWidth: "600px",
                backgroundColor: (theme) => theme.palette.blackProLighter,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <img
                src={referencesPracticesImage}
                alt={"100+ pratiques référencées"}
                style={{
                  maxWidth: "350px",
                }}
              />

              <img
                src={pratiquesJpg}
                alt={"100+ pratiques référencées"}
                style={{
                  maxWidth: "350px",
                }}
              />
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Branding Bold",
                  fontSize: "24px",
                  textAlign: "center",
                  color: "white",
                }}
              >
                Consultez ce PDF pour voir si vous êtes concerné
              </Typography>
              <InexButton
                text={"Voir le PDF"}
                variant={"texticon"}
                textWithGradient={false}
                icon={<PictureAsPdfRounded />}
                onClick={() => {
                  window.open(
                    `https://medias.inrees.com/administratif/Inexplore_Praticiens_Pratiques_V6.pdf`,
                    "_blank",
                  );
                }}
                sx={{
                  zIndex: 1,
                  marginTop: 1,
                  width: "300px",
                  height: "50px",
                  background: (theme) => theme.palette.primary.main,
                  border: (theme) => theme.palette.primary.main + " solid 3px",
                  color: "white",
                  transition: "background 0.3s, color 0.3s, border-color 0.3s",
                  "&:hover": {
                    background: "white",
                    border: (theme) => theme.palette.primary.main + " solid 3px",
                    "& > p": {
                      color: (theme) => theme.palette.primary.main,
                    },
                    "& > svg": {
                      fill: (theme) => theme.palette.primary.main,
                      color: (theme) => theme.palette.primary.main,
                    },
                  },
                }}
              />

            </SpecialCard>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
            position: "relative",
          }}
        >
          <ArrowRightBackground
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
            }}
          />
          <ZoomBg
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
            }}
          />
          <Box
            sx={{
              mt: 10,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontWeight: 500,
                margin: 0,
                textAlign: "center",
                color: "white",
              }}
            >
              3 paliers d'engagement envers
              <GradientTypo
                variant={"h2"}
                background={theme.palette.linearPro}
                sx={{
                  fontFamily: "YesevaOne",
                  textTransform: "lowercase",
                  textAlign: "center",
                  margin: 0,
                  fontWeight: 500,
                  "&:first-letter": {
                    textTransform: "lowercase !important",
                  },
                }}
              >
                &nbsp;{`la communauté`}
              </GradientTypo>
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "column", md: "row" },
              justifyContent: { xs: "center", md: "space-between" },
              flexWrap: "wrap",
              alignItems: "center",
              width: "100%",
              paddingTop: 5,
              position: "relative",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: { xs: "100%", md: "45%", lg: "31%" },
                justifyContent: "center",
                mt: 3,
              }}
            >
              <SpecialCard
                sx={{
                  backgroundColor: (theme) => theme.palette.blackPro,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  maxWidth: "400px",
                }}
              >
                <Chip
                  label={"1er palier"}
                  sx={{
                    backgroundColor: (theme) => theme.palette.greenPro,
                    color: "white",
                    fontWeight: "bold",
                    borderRadius: "5px",
                    padding: 0.5,
                  }}
                />
                <Typography
                  sx={{
                    mt: 1,
                    fontWeight: "bold",
                    fontSize: "28px",
                    color: (theme) => theme.palette.greenPro,
                  }}
                >
                  Praticien abonné
                </Typography>
                <Typography
                  sx={{
                    fontSize: "20px",
                    color: "white",
                  }}
                >
                  Vous rejoignez notre communauté et accédez à tous nos contenus, 
                  notamment aux podcasts hebdomadaires.
                </Typography>
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nwrap",
                  }}
                >
                  <Level1Arrow
                    style={{
                      minWidth: "25px",
                      minHeight: "25px",
                      marginRight: "5px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "white",
                      mb: 3.5,
                      maxWidth: "300px",
                    }}
                  >
                    Prochain cap ! Découvrez et signez notre Charte éthique pour devenir praticien engagé.
                  </Typography>
                </Box>
              </SpecialCard>
            </Box>

            <Box
              sx={{
                display: "flex",
                width: { xs: "100%", md: "45%", lg: "31%" },
                justifyContent: "center",
                mt: 3,
              }}
            >
              <SpecialCard
                sx={{
                  backgroundColor: (theme) => theme.palette.blackPro,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  maxWidth: "400px",
                }}
              >
                <Chip
                  label={"2e palier"}
                  sx={{
                    backgroundColor: (theme) => theme.palette.bluePro,
                    color: "white",
                    fontWeight: "bold",
                    borderRadius: "5px",
                    padding: 0.5,
                  }}
                />
                <Typography
                  sx={{
                    mt: 1,
                    fontWeight: "bold",
                    fontSize: "28px",
                    color: (theme) => theme.palette.bluePro,
                  }}
                >
                  Praticien engagé
                </Typography>
                <Typography
                  sx={{
                    fontSize: "20px",
                    color: "white",
                  }}
                >
                  Vous vous engagez à respecter notre charte éthique 
                  et pouvez participer dès maintenant aux prochains événements.
                </Typography>
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nwrap",
                  }}
                >
                  <Level2Arrow
                    style={{
                      minWidth: "25px",
                      minHeight: "25px",
                      marginRight: "5px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "white",
                      mb: 0.5,
                      maxWidth: "300px",
                    }}
                  >
                    Prochain cap ! Complétez le formulaire de candidature afin de nous faire 
                    connaître votre pratique et entamez votre parcours vers la labellisation.
                  </Typography>
                </Box>
              </SpecialCard>
            </Box>

            <Box
              sx={{
                display: "flex",
                width: { xs: "100%", md: "100%", lg: "31%" },
                justifyContent: "center",
                mt: 3,
              }}
            >
              <SpecialCard
                sx={{
                  backgroundColor: (theme) => theme.palette.blackPro,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  maxWidth: "400px",
                }}
              >
                <Chip
                  label={"3ème palier"}
                  sx={{
                    backgroundColor: (theme) => theme.palette.purplePro,
                    color: "white",
                    fontWeight: "bold",
                    borderRadius: "5px",
                    padding: 0.5,
                  }}
                />
                <Typography
                  sx={{
                    mt: 1,
                    fontWeight: "bold",
                    fontSize: "28px",
                    color: (theme) => theme.palette.purplePro,
                  }}
                >
                  Praticien labellisé
                </Typography>
                <Typography
                  sx={{
                    fontSize: "20px",
                    color: "white",
                  }}
                >
                  Après validation par notre Comité déontologique, vous profiterez, 
                  en plus de nos ressources, de ces différents avantages :
                </Typography>
                <Box
                  sx={{
                    mt: 1,
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nwrap",
                  }}
                >
                  <Level1Arrow
                    style={{
                      minWidth: "25px",
                      minHeight: "25px",
                      marginRight: "5px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "white",
                    }}
                  >
                    Le label Inexploré Praticiens
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nwrap",
                  }}
                >
                  <Level2Arrow
                    style={{
                      minWidth: "25px",
                      minHeight: "25px",
                      marginRight: "5px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "white",
                    }}
                  >
                    Une fiche dédiée sur notre site
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "nwrap",
                  }}
                >
                  <Level1Arrow
                    style={{
                      minWidth: "25px",
                      minHeight: "25px",
                      marginRight: "5px",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: "16px",
                      color: "white",
                    }}
                  >
                    Une mise en avant dans notre annuaire
                  </Typography>
                </Box>
              </SpecialCard>
            </Box>
          </Box>
        </Box>
        <Reasons5 />
      </CenteredSiteBlock>
    </Container>
  );
};

export default JoinUs;
